/* cs-anchor.js · LOT 10.13 (audit 10.09.2026) — o singură logică de aterizare pe formularul de programare,
   pentru toate familiile de pagini (v18 · cs26 · PF26/CL26/CBJ · Riviera DONNA · DONNA Lookbook/Privée · PDP DONNA).

   Principiu: NU înlocuiește handlerele existente (tracking-ul lor rămâne intact) — aliniază geometria pe care
   o folosesc toate: `scroll-padding-top` pe <html> (înălțimea reală a grupului sticky: bară de invitație + header + 24 px)
   și `scroll-margin-top` pe fiecare țintă posibilă din secțiunea formularului (secțiune · formular · marker · orice [id]),
   astfel încât primul element vizibil al secțiunii (kicker/titlu sau formularul) să aterizeze exact sub header.
   Funcționează identic pentru: click pe ancoră, scrollIntoView din JS-ul familiilor, hash la încărcare, settle PF26/CBJ/CL26.

   În plus: (1) ascunde barele sticky de programare cât timp formularul e vizibil (html.cs-lead-form-visible);
   (2) preselectează showroom-ul din linkurile pe orașe și linia din CTA-urile cu data-lead-line / data-cs-lead-line;
   (3) un singur eveniment dataLayer `cta_click` pentru toate CTA-urile care duc la formular.
   Fișierele contract (cs-form-programeaza.liquid · cs-lead-submit.js · cs-attribution.js) rămân neatinse. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  if (root.dataset.csAnchorReady === '1') return;
  root.dataset.csAnchorReady = '1';

  var GAP = 24;                 /* respirație sub grupul sticky */
  var TOPLINE_FALLBACK = 44;    /* bara de invitație (cs-handoff) */
  var SHOWROOMS = { 'bucuresti': 'bucuresti', 'bucurești': 'bucuresti', 'bucharest': 'bucuresti', 'cluj': 'cluj', 'cluj-napoca': 'cluj', 'timisoara': 'timisoara', 'timișoara': 'timisoara', 'constanta': 'constanta', 'constanța': 'constanta' };

  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function forms() { return $$('form[data-cs-lead-form]'); }
  function sectionOf(el) { return el && (el.closest('ana-booking,olivian-booking') || el.closest('.shopify-section') || el.closest('section') || el.parentElement); }
  function visible(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.height > 0 && r.width > 0; }

  /* ---------- geometria grupului sticky ---------- */
  function headerHeight() {
    var consultantNav = $('.an-nav,.ov-nav');
    if (visible(consultantNav)) {
      var consultantStyle = getComputedStyle(consultantNav);
      if (consultantStyle.position === 'sticky' || consultantStyle.position === 'fixed') return consultantNav.offsetHeight || 0;
    }
    var h = $('.shopify-section--header') || $('#shopify-section-header') || $('.shopify-section-group-header-group');
    if (!h) return 0;
    var st = getComputedStyle(h);
    if (st.position !== 'sticky' && st.position !== 'fixed') {
      var inner = h.querySelector('[class*="header"]');
      var stIn = inner ? getComputedStyle(inner) : null;
      if (!stIn || (stIn.position !== 'sticky' && stIn.position !== 'fixed')) return 0;
    }
    return h.offsetHeight || 0;
  }
  function toplineHeight() {
    var bar = $('[data-cs-invitation]');
    if (!bar) return 0;
    return bar.offsetHeight || TOPLINE_FALLBACK;
  }
  /* The discovery controller knows whether the invitation occupies the destination. */
  function stickyAt(y) {
    var shown = root.classList.contains('cs-invitation-revealed');
    try {
      if (window.csDiscoveryBooking && typeof window.csDiscoveryBooking.invitationAt === 'function') {
        shown = window.csDiscoveryBooking.invitationAt(y);
      }
    } catch (_) { /* retain the invitation's actual state */ }
    return headerHeight() + (shown ? toplineHeight() : 0);
  }

  /* primul element vizibil al secțiunii formularului: kicker/titlu al secțiunii sau formularul însuși */
  function contentTop(section, form) {
    if (section && section.matches('ana-booking,olivian-booking')) return section.getBoundingClientRect().top;
    var fr = form.getBoundingClientRect();
    var best = fr.top;
    $$('.section-header, .section-title, .prose, h1, h2, h3, .h1, .h2, .h3, .eyebrow, .c-eyebrow, .kicker', section).forEach(function (el) {
      if (!visible(el) || form.contains(el)) return;
      var r = el.getBoundingClientRect();
      if (r.top < best && r.bottom <= fr.top + 4) best = r.top;
    });
    return best;
  }

  var applying = false;
  function apply() {
    if (applying) return;
    applying = true;
    try {
      var list = forms();
      if (!list.length) return;
      var y = window.scrollY || 0;
      list.forEach(function (form) {
        var section = sectionOf(form);
        if (!section) return;
        var ct = contentTop(section, form) + y;               /* document coordinates */
        var pad = stickyAt(Math.max(0, ct - stickyAt(ct))) + GAP;
        root.style.scrollPaddingTop = pad + 'px';
        var targets = [section, form].concat($$('.cs-anchor-marker', form), $$('[id]', section).filter(function (el) { return el !== form && el.contains(form); }));
        targets.forEach(function (t) {
          if (!t || t === root) return;
          var top = t.getBoundingClientRect().top + y;
          var m = Math.round(top - ct);
          t.style.scrollMarginTop = m + 'px';
          t.style.scrollMarginBlockStart = m + 'px';
        });
      });
    } finally { applying = false; }
  }

  /* A header/layout change during native smooth scrolling can invalidate its initial destination.
     Settle only this requested landing; real user input cancels it immediately. */
  var landing = null;
  function cancelLanding() {
    if (landing) clearTimeout(landing.timer);
    landing = null;
    root.classList.remove('cs-anchor-travel');
  }
  function settleLanding(form) {
    cancelLanding();
    if (!form || !form.isConnected) return;
    var run = { form: form, started: Date.now(), quiet: Date.now(), lastY: null, lastTop: null, good: 0, corrections: 0, timer: null };
    landing = run;
    root.classList.add('cs-anchor-travel');
    function checkLanding() {
      if (landing !== run) return;
      var now = Date.now(), section = sectionOf(run.form);
      if (!run.form.isConnected || !section || now - run.started > 2400) { cancelLanding(); return; }
      var y = window.scrollY || 0, top = contentTop(section, run.form);
      if (run.lastY === null || Math.abs(y - run.lastY) > 1 || Math.abs(top - run.lastTop) > 1) {
        run.quiet = now; run.good = 0;
      }
      run.lastY = y; run.lastTop = top;
      if (now - run.started >= 250 && now - run.quiet >= 120) {
        apply();
        var absolute = top + y;
        var pad = stickyAt(Math.max(0, absolute - stickyAt(absolute))) + GAP;
        var height = Math.max(root.scrollHeight, doc.body ? doc.body.scrollHeight : 0);
        var limit = Math.max(0, height - (root.clientHeight || window.innerHeight));
        var targetY = Math.min(limit, Math.max(0, absolute - pad));
        if (Math.abs(targetY - y) > 1) {
          if (run.corrections >= 2) { cancelLanding(); return; }
          run.corrections++; run.good = 0; run.quiet = now;
          var behavior = root.style.getPropertyValue('scroll-behavior');
          var priority = root.style.getPropertyPriority('scroll-behavior');
          root.style.setProperty('scroll-behavior', 'auto', 'important');
          try { window.scrollTo({ top: targetY, behavior: 'auto' }); }
          finally {
            if (behavior) root.style.setProperty('scroll-behavior', behavior, priority);
            else root.style.removeProperty('scroll-behavior');
          }
        } else {
          if (!run.good) run.good = now;
          if (now - run.good >= 200) { cancelLanding(); return; }
        }
      }
      run.timer = setTimeout(checkLanding, 80);
    }
    run.timer = setTimeout(checkLanding, 80);
  }

  /* ---------- ținte de tip formular ---------- */
  function hashTarget(a) {
    var href = a.getAttribute('href') || '';
    var i = href.indexOf('#');
    if (i < 0 || href.length === i + 1) return null;
    var before = href.slice(0, i);
    if (before) {
      var u; try { u = new URL(href, location.href); } catch (e) { return null; }
      if (u.origin !== location.origin || u.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '')) return null;
    }
    var id = decodeURIComponent(href.slice(i + 1));
    return doc.getElementById(id) || (doc.getElementsByName(id)[0] || null);
  }
  function formFor(target) {
    if (!target) return null;
    if (target.matches && target.matches('form[data-cs-lead-form]')) return target;
    var inside = target.closest && target.closest('form[data-cs-lead-form]');
    if (inside) return inside;
    return target.querySelector ? target.querySelector('form[data-cs-lead-form]') : null;
  }

  /* ---------- preselectări (contractul nu se atinge: doar select-urile UI existente) ---------- */
  function setSelect(sel, value) {
    if (!sel || !value) return false;
    var ok = Array.prototype.some.call(sel.options, function (o) { return o.value === value; });
    if (!ok) return false;
    if (sel.value === value) return true;
    sel.value = value;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  function preselect(a, form) {
    var line = a.getAttribute('data-cs-lead-line') || a.getAttribute('data-lead-line');
    if (line) setSelect($('select[name="cs_ui_lead_line"]', form), line);
    var city = a.getAttribute('data-cs-showroom') || a.getAttribute('data-showroom');
    if (!city) {
      var txt = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (txt.length <= 16 && SHOWROOMS[txt]) city = SHOWROOMS[txt];
    }
    if (city) {
      var sr = $('select[name="contact[showroom]"]', form);
      if (sr) setSelect(sr, SHOWROOMS[city] || city);
    }
  }

  /* ---------- tracking unificat ---------- */
  function track(a, form) {
    try {
      var sec = sectionOf(a);
      window.dataLayer = window.dataLayer || [];
      var label = (a.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
      var href = a.getAttribute('href') || ('#' + (form.id || 'appointment'));
      var p = location.pathname;
      var pageType = p === '/' || /^\/[a-z]{2}(-[a-z]{2})?\/?$/i.test(p) ? 'home' : /\/products\//.test(p) ? 'product' : /\/collections\//.test(p) ? 'collection' : /\/pages\//.test(p) ? 'page' : /\/blogs\//.test(p) ? 'blog' : 'other';
      var lineSel = $('select[name="cs_ui_lead_line"]', form);
      var line = (lineSel && lineSel.value) || form.getAttribute('data-cs-lead-line-preset') || '';
      if (line === 'none') line = '';
      /* Addendum B (audit extern 10.09, F09): un singur eveniment, fără date personale; cheile noi (cta_label, destination, page_type, line) + cele existente. */
      window.dataLayer.push({
        event: 'cta_click',
        cta_label: label,
        cta_text: label,
        destination: href,
        cta_href: href,
        cta_location: a.getAttribute('data-cta-location') || (sec && (sec.id || sec.className.split(' ')[0])) || 'page',
        cta_form_id: form.getAttribute('data-cs-form-id') || 'appointment',
        page_type: pageType,
        line: line,
        page_path: p
      });
    } catch (e) { /* noop */ }
  }

  /* ---------- click (capture: rulează înaintea handlerelor familiilor, nu le oprește) ---------- */
  doc.addEventListener('click', function (e) {
    if (e.button !== 0) return;
    var a = e.target && e.target.closest && e.target.closest('a[href*="#"], button[data-cs26-appointment]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var target = a.tagName === 'BUTTON' ? doc.getElementById('appointment') : hashTarget(a);
    var form = formFor(target);
    if (!form) return;
    apply();                                   /* geometrie proaspătă (lazy images, fonturi) */
    preselect(a, form);
    track(a, form);
    settleLanding(form);
  }, true);

  /* ---------- hash la încărcare / hashchange: re-aterizare după ce stilurile inline există ---------- */
  function landOnHash() {
    if (!location.hash || location.hash.length < 2) return;
    var t; try { t = doc.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (e) { t = null; }
    if (!formFor(t)) return;
    apply();
    settleLanding(formFor(t));
    t.scrollIntoView({ behavior: 'auto', block: 'start' });
  }
  window.addEventListener('hashchange', function () { setTimeout(landOnHash, 0); });

  /* ---------- formular vizibil → barele sticky de programare se retrag ---------- */
  function observeForms() {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var any = forms().some(function (f) { return f.dataset.csInView === '1'; });
      entries.forEach(function (en) { en.target.dataset.csInView = en.isIntersecting ? '1' : '0'; });
      any = forms().some(function (f) { return f.dataset.csInView === '1'; });
      root.classList.toggle('cs-lead-form-visible', any);
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
    forms().forEach(function (f) { if (f.dataset.csObserved !== '1') { f.dataset.csObserved = '1'; io.observe(f); } });
  }

  /* ---------- formular: ocazie cu o singură opțiune → selectată și retrasă din UI (contractul trimite același cod) ---------- */
  function singleOptionOccasion() {
    forms().forEach(function (form) {
      var sel = $('select[name="cs_ui_lead_occasion"]', form);
      if (!sel || sel.dataset.csSingle === '1') return;
      var real = Array.prototype.filter.call(sel.options, function (o) { return o.value !== ''; });
      if (real.length !== 1) return;
      sel.dataset.csSingle = '1';
      if (sel.value !== real[0].value) { sel.value = real[0].value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      var wrap = (sel.parentElement && sel.parentElement.closest('.form-control, .form__input-wrapper, .field')) || sel.parentElement; /* select-ul poartă el însuși clasa .select → căutăm din părinte */
      if (wrap && wrap !== form) { wrap.hidden = true; wrap.setAttribute('data-cs-single-occasion', '1'); }
    });
  }

  /* ---------- formular: eticheta butonului de trimitere, per pagină (data-cs-submit-label pe blocul „Întâlnirea ta privată”) ---------- */
  function submitLabels() {
    $$('[data-cs-submit-label]').forEach(function (src) {
      var label = src.getAttribute('data-cs-submit-label'); if (!label) return;
      var sec = src.closest('.shopify-section'); var next = sec && sec.nextElementSibling;
      var form = next && $('form[data-cs-lead-form]', next);
      if (!form) return;
      $$('button[type="submit"]', form).forEach(function (btn) {
        if (btn.dataset.csLabel === '1') return;
        var walker = doc.createTreeWalker(btn, NodeFilter.SHOW_TEXT), node, done = false;
        while ((node = walker.nextNode())) {
          var v = node.nodeValue.trim();
          if (v === 'PROGRAMEAZĂ O ÎNTÂLNIRE' || v === 'BOOK AN APPOINTMENT') { node.nodeValue = node.nodeValue.replace(v, label); done = true; }
        }
        if (done) btn.dataset.csLabel = '1';
      });
    });
  }

  /* ---------- init ---------- */
  var t0 = null;
  function schedule() { clearTimeout(t0); t0 = setTimeout(apply, 80); }
  function init() {
    singleOptionOccasion(); submitLabels();
    apply(); observeForms();
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule, { passive: true });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(schedule);
    window.addEventListener('load', function () { apply(); setTimeout(landOnHash, 60); });
    doc.addEventListener('shopify:section:load', function () { singleOptionOccasion(); submitLabels(); schedule(); observeForms(); });
    doc.addEventListener('cs:discovery-change', schedule);
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function (type) {
      doc.addEventListener(type, cancelLanding, { capture: true, passive: true });
    });
    window.addEventListener('pagehide', cancelLanding);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
})();

